module.exports = __webpack_public_path__ + "static/media/218.6bca912b.png";